export const CHALLAN_INPUT_PLACEHOLDER = 'e.g. MH05VF1234'
export const VEHICLE_DATA = 'vehicleData'
export const VIEW_CHALLANS = 'View challans'
export const CHALLAN_WIDGET_INPUT = 'challanWidgetInput'
export const WIDGET_INPUT = 'widgetInput'
export const REG_NO_ERROR = 'Enter a valid registration number'

export const ARROW_RIGHT_URL = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/arrow_right_a843cff96d.svg'
export const SEO_CHALLAN_FALLBACK_APPLINK = 'https://ackoctv.onelink.me/pNs0/xk00tycj'
export const SEM_PMAX_META_FALLBACK_APPLINK = 'https://ackoctv.onelink.me/pNs0/1vjlyiw0'
